import { createFileRoute, redirect } from '@tanstack/react-router'
import { PreferencesLegacyIframe } from '@admin/preferences/PreferencesLegacyIframe'

export const Route = createFileRoute('/_auth/preferences/globalTables')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (
      !scopedEnablements.global().hasStandardEnablement('GlobalTable', 'MANAGE') ||
      !scopedEnablements.global().hasStandardEnablement('Assumption', 'MANAGE')
    ) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  return <PreferencesLegacyIframe name="globalTables" />
}
